import { gql } from '@apollo/client';
export const GET_CHATWOOT_DATA = gql `
  query GetChatwootData {
    driverBackOffice {
      getChatwootData {
        autoParkId
        websiteToken
        identifierHash
      }
    }
  }
`;
